<template>
  <div>
    <div class="maintenance-field">
      <div class="error-page">
        <div class="image-field">
          <img src="/img/maintenance.svg" alt="404-image" />
        </div>
        <div class="bottom-field">
          <p class="error-page-header">
            {{ $t('Uygulamamızda şu an bakım çalışması yapılmaktadır') }}
          </p>
          <p class="error-page-text">
            {{ $t('sonrasında yeniden kullanabilirsiniz') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang="less" scoped>
.error-page {
  min-height: 100vh;
  background: linear-gradient(193deg, rgba(255, 255, 255, 0.12) 8.91%, rgba(255, 255, 255, 0) 91.83%),
    radial-gradient(
      114.97% 49.35% at 74.1% 90%,
      rgba(251, 213, 235, 0.2) 0%,
      rgba(251, 213, 235, 0.1) 0.01%,
      rgba(251, 213, 235, 0) 100%
    ),
    radial-gradient(90.78% 72.48% at 45.97% 66.17%, rgba(232, 218, 248, 0.2) 0%, rgba(232, 218, 248, 0) 100%),
    radial-gradient(182.73% 72.84% at 13.16% 17.61%, rgba(249, 227, 221, 0.2) 0%, rgba(249, 227, 221, 0) 100%),
    radial-gradient(267.01% 142.45% at 98.92% 8.28%, rgba(192, 230, 251, 0.2) 0%, rgba(192, 230, 251, 0) 100%), #fff;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;

  .image-field {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
    margin: 0px auto;
  }

  .bottom-field {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .error-page-header {
    font-size: 45px;
    line-height: 64px;
    letter-spacing: -2px;
    color: black;
    margin-top: 64px;
  }

  .error-page-text {
    font-size: 22px;
    line-height: 32px;
    letter-spacing: -0.528px;
    color: #000;
    margin-top: 24px;
  }
}
</style>
